// AddVisitor.js - With OTP Verification + React-Select
import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ProductContext } from "../context/AppContext";
import Header from "./Header";
import Swal from "sweetalert2";
import axios from "axios";
import Select from "react-select";
import {
  Button,
  Card,
  Spinner,
  Row,
  Col,
  Form,
  Badge,
  Alert,
} from "react-bootstrap";
import {
  Person,
  Phone,
  Envelope,
  GeoAlt,
  Calendar3,
  Image as ImageIcon,
  FileText,
  Building,
  People,
  Upload,
  ShieldLock,
} from "react-bootstrap-icons";

import Webcam from "react-webcam";
import { FaCamera } from "react-icons/fa";
import moment from "moment";

const AddVisitor = () => {
  const navigate = useNavigate();
  const { StaffData, GetstudentData } = useContext(ProductContext);
  const authtoken = localStorage.getItem("token");

  const webcamRef = useRef(null);
  const cameraInputRef = useRef(null);

const [showWebcam, setShowWebcam] = useState({
  photo: false,
  document: false,
});

const [activeType, setActiveType] = useState(""); // "photo" or "document"

// iOS WebView me getUserMedia (react-webcam) glitch karta hai, isliye wahan native camera kholo
const isIOS =
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

const openWebcam = (type) => {
  setActiveType(type);
  if (isIOS) {
    cameraInputRef.current?.click();
    return;
  }
  setShowWebcam((prev) => ({
    ...prev,
    [type]: true,
  }));
};

const handleNativeCapture = (e) => {
  const file = e.target.files[0];
  if (activeType === "photo") {
    handlePhotoChange(file);
  } else if (activeType === "document") {
    handleDocumentChange(file);
  }
  e.target.value = "";
};

const captureImage = () => {
  const imageSrc = webcamRef.current.getScreenshot();

  fetch(imageSrc)
    .then((res) => res.blob())
    .then((blob) => {
      const file = new File([blob], `${activeType}.jpg`, {
        type: "image/jpeg",
      });

      if (activeType === "photo") {
        handlePhotoChange(file);
      } else if (activeType === "document") {
        handleDocumentChange(file);
      }
    });

  setShowWebcam((prev) => ({
    ...prev,
    [activeType]: false,
  }));
};

  const ParentName =
    GetstudentData?.father_full_name || GetstudentData?.mother_full_name;
  const ParentMobile =
    GetstudentData?.father_mobile_no || GetstudentData?.mother_mobile_no;
  const ParentEmail =
    GetstudentData?.father_email || GetstudentData?.mother_full_name;
  const ParentAddress = StaffData?.data?.data?.address || "";

  const [loading, setLoading] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otp, setOtp] = useState("");
  const [uuid, setUuid] = useState("");

  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [staffOptions, setStaffOptions] = useState([]);

  const [VisitorTypeData, setVisitorTypeData] = useState("");
  const [RelationData, setRelationData] = useState("");
  const [previews, setPreviews] = useState({ photo: null, document: null });

  const StudentClass1 = Number(GetstudentData?.select_class);
  const StudentClassSection1 = GetstudentData?.class_section_id;
  const StudentId = GetstudentData?.id;

  useEffect(() => {
    if (GetstudentData) {
      const StudentClass1 = Number(GetstudentData?.select_class);
      const StudentClassSection1 = GetstudentData?.class_section_id;
      const StudentId = GetstudentData?.id;

      setFormData((prev) => ({
        ...prev,
        class_id: StudentClass1 || "",
        section_id: StudentClassSection1 || "",
        student_id: StudentId || "",
      }));
    }
  }, [GetstudentData]);

  const [formData, setFormData] = useState({
    name: "",
    mobile_no: "",
    email: "",
    contact_to: "",
    contact_to_id: "",
    contact_email: "",
    contactto_name: "",
    purpose: "",
    createdBy: "",
    address: "",
    visitor_type: "",
    class_id: StudentClass1,
    section_id: StudentClassSection1,
    student_id: StudentId,
    visitor_relation: "",
    visit_date: "",
    in_time: "",
    department_id: null,
    photo: null,
    document: null
  });

  const today = new Date().toISOString().split("T")[0];

  // Fetch Departments
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const res = await axios.get(
          "https://api.mirai.healthcare/api/masters/department/",
          {
            headers: { "x-auth": authtoken },
          }
        );
        const options = res.data?.data?.map((d) => ({
          label: d.department_name,
          value: d.id,
        }));
        setDepartmentOptions(options);
      } catch (err) {
        console.error("Department fetch failed:", err);
      }
    };
    fetchDepartments();
  }, [authtoken]);

  // Fetch Staff when department changes
  useEffect(() => {
    const fetchStaff = async () => {
      if (!formData.department_id) {
        setStaffOptions([]);
        return;
      }
      try {
        const res = await axios.get(
          `https://api.mirai.healthcare/api/staff-Registration/department/${formData.department_id}`,
          { headers: { "x-auth": authtoken } }
        );
        const options = res.data?.data?.data?.map((s) => ({
          label: `${s.staff_full_name} ${s?.employee_code}`,
          value: s.id || s.employee_code,
        }));
        setStaffOptions(options);
      } catch (err) {
        console.error("Staff fetch failed:", err);
        setStaffOptions([]);
      }
    };
    fetchStaff();
  }, [formData.department_id, authtoken]);

  const handleDropdownVisitorTypeChange = (item) => {
  setVisitorTypeData(item.value);

  if (item.value === "Student") {
    setFormData((prev) => ({
      ...prev,
      visitor_type: item.value,
      name: GetstudentData?.student_full_name || "",
      mobile_no: GetstudentData?.father_mobile_no || "",
      email: GetstudentData?.father_email || "",
      address: GetstudentData?.contact_address || "",
      visitor_relation: ""
    }));
  } 
  else if (item.value === "Parent") {
    setFormData((prev) => ({
      ...prev,
      visitor_type: item.value,
      name: "",
      mobile_no: "",
      email: "",
      address: "",
      visitor_relation: ""
    }));
  } 
  else if (item.value === "Guardian") {
    // ✅ FULL RESET (IMPORTANT)
    setFormData((prev) => ({
      ...prev,
      visitor_type: item.value,
      name: "",
      mobile_no: "",
      email: "",
      address: "",
      visitor_relation: ""   // reset relation also
    }));
  }
};
  const handleDropdownRelationDataChange = (item) => {
  setRelationData(item.value);

  if (item.value === "Father") {
    setFormData((prev) => ({
      ...prev,
      visitor_relation: item.value,
      name: GetstudentData?.father_full_name || "",
      mobile_no: GetstudentData?.father_mobile_no || "",
      email: GetstudentData?.father_email || "",
      address: GetstudentData?.contact_address,
    }));
  } 
  else if (item.value === "Mother") {
    setFormData((prev) => ({
      ...prev,
      visitor_relation: item.value,
      name: GetstudentData?.mother_full_name || "",
      mobile_no: GetstudentData?.mother_mobile_no || "",
      email: GetstudentData?.mother_email || "",
      address: GetstudentData?.contact_address,
    }));
  } 
  else if (item.value === "Guardian") {
    // ✅ CLEAR fields for manual entry
    setFormData((prev) => ({
      ...prev,
      visitor_relation: item.value,
      name: "",
      mobile_no: "",
      email: "",
      address: "",
    }));
  }
};

const handlePhotoChange = (file) => {
  if (!file) return;

  setFormData((prev) => ({
    ...prev,
    photo: file
  }));

  setPreviews((prev) => ({
    ...prev,
    photo: URL.createObjectURL(file)
  }));
};

const handleDocumentChange = (file) => {
  if (!file) return;

  setFormData((prev) => ({
    ...prev,
    document: file
  }));

  setPreviews((prev) => ({
    ...prev,
    document: URL.createObjectURL(file)
  }));
};

  const VisitorTypeOptions = [
    { label: "Student", value: "Student" },
    { label: "Parent", value: "Parent" },
  ];

  const RelationOptions = [
    ...(GetstudentData?.father_full_name
      ? [{ label: "Father", value: "Father" }]
      : []),
    ...(GetstudentData?.mother_full_name
      ? [{ label: "Mother", value: "Mother" }]
      : []),
    ...(GetstudentData?.guardian_name
      ? [{ label: "Guardian", value: "Guardian" }]
      : []),
  ];

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleFileChange = (key, file) => {
    if (file) {
      handleChange(key, file);
      setPreviews((prev) => ({
        ...prev,
        [key]: URL.createObjectURL(file),
      }));
    }
  };
  const relationOptions = [];

  if (GetstudentData?.father_full_name) {
    relationOptions.push({ label: "Father", value: "Father" });
  }

  if (GetstudentData?.mother_full_name) {
    relationOptions.push({ label: "Mother", value: "Mother" });
  }

  const [resendTimer, setResendTimer] = useState(0);

  // Update sendOtp function to start timer
  const sendOtp = async () => {
    if (!formData.mobile_no) {
      Swal.fire("Error", "Mobile number is missing", "error");
      return;
    }

    setOtpLoading(true);
    try {
      const res = await axios.post(
        "https://api.mirai.healthcare/api/sms/airtel/send-otp/custom",
        {
          mobile_no: formData.mobile_no,
          email: formData.email || "",
          name: formData.name.split(" ")[0] || "Visitor",
          type: "visitor",
        },
        {
          headers: {
            "x-auth": authtoken,
            "Content-Type": "application/json",
          },
        }
      );

      const receivedUuid =
        res.data?.message?.data?.uuid || res.data?.data?.uuid;

      if (receivedUuid) {
        setUuid(receivedUuid);
        setOtpSent(true);
        setResendTimer(60); // Start 1-minute timer
        Swal.fire({
          icon: "success",
          title: "OTP Sent!",
          text: `OTP sent to ${formData.mobile_no} or ${formData.email}`,
          timer: 3000,
        });
      }
    } catch (err) {
      console.error(err.response?.data);
      Swal.fire(
        "Failed",
        err.response?.data?.message || "Could not send OTP",
        "error"
      );
    } finally {
      setOtpLoading(false);
    }
  };

  // Add timer countdown effect
  useEffect(() => {
    let interval;
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [resendTimer]);

  // Verify OTP - UUID + OTP dono bhejo
  const verifyOtp = async () => {
    if (!otp || otp.length !== 6) {
      Swal.fire("Invalid", "Enter 6-digit OTP", "warning");
      return;
    }
    if (!uuid) {
      Swal.fire("Error", "UUID missing. Please send OTP again.", "error");
      setOtpSent(false);
      return;
    }

    setOtpLoading(true);
    try {
      const res = await axios.post(
        "https://api.mirai.healthcare/api/sms/airtel/verify-otp",
        {
          uuid: uuid, // ← YEH ADD KARNA THA!
          otp: otp,
        },
        {
          headers: {
            "x-auth": authtoken,
            "Content-Type": "application/json",
          },
        }
      );

      if (res.data.success || res.data.message?.success) {
        setOtpVerified(true);
        Swal.fire({
          icon: "success",
          title: "Verified ✓",
          text: "Mobile number verified successfully!",
          timer: 2000,
        });
      }
    } catch (err) {
      console.error(err.response?.data);
      Swal.fire(
        "Invalid OTP",
        err.response?.data?.message || "Wrong OTP",
        "error"
      );
      setOtpVerified(false);
    } finally {
      setOtpLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (otpRequired && !otpVerified) {
      Swal.fire(
        "Verify First",
        "Please verify your mobile number with OTP",
        "warning"
      );
      return;
    }

    if (
      !formData.name ||
      !formData.mobile_no ||
      !formData.department_id ||
      !formData.purpose ||
      !formData.visit_date
    ) {
      Swal.fire("Error", "Please fill all required fields", "error");
      return;
    }

    const [year, month, day] = formData.visit_date.split("-");
    const formattedDate = `${day}-${month}-${year}`;
    const currentTime = new Date().toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

    const data = new FormData();
    data.append("name", formData.name);
    data.append("mobile_no", formData.mobile_no);
    if (formData.email) data.append("email", formData.email);
    data.append("address", formData.address);
    // data.append("contact_to", formData.contact_to);

    if (formData?.contact_to) data.append("contact_to", formData?.contact_to);
    if (formData?.contact_to_id) data.append("contact_to_id", formData?.contact_to_id);

    data.append("purpose", formData.purpose);
    data.append("visit_date", formattedDate);
    data.append("visitor_type", "Student");
    data.append("department_id", formData.department_id);

    data.append("contact_email", formData.contact_email);
    data.append("contactto_name", formData.contactto_name);
    data.append("createdBy", formData.createdBy);
    data.append("class_id", StudentClass1);
    data.append("section_id", StudentClassSection1);
    data.append("student_id", StudentId);
    data.append("visitor_relation", formData?.visitor_relation);
    // data.append("in_time", formData.in_time);
    data.append("in_time", currentTime);

    if (formData.photo) data.append("photo", formData.photo);
    if (formData.document) data.append("document", formData.document);

    try {
      setLoading(true);
      await axios.post("https://api.mirai.healthcare/api/visitors", data, {
        headers: {
          "x-auth": authtoken,
          "Content-Type": "multipart/form-data",
        },
      });

      Swal.fire({
        title: "Success!",
        text: "Visitor pass created successfully",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });
      navigate("/visitor");
    } catch (err) {
      Swal.fire(
        "Error",
        err.response?.data?.message || "Failed to create visitor pass",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // Cleanup previews
  useEffect(() => {
    return () => {
      if (previews.photo) URL.revokeObjectURL(previews.photo);
      if (previews.document) URL.revokeObjectURL(previews.document);
    };
  }, [previews]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "0.75rem",
      padding: "0.25rem",
    }),
  };

  const [attendanceDetails, setAttendanceDetails] = useState([]);
    const [loadingAttendance, setLoadingAttendance] = useState(false);
    const fetchStaffAttendance = async (staffId, selectedDate) => {
  if (!staffId) {
    setAttendanceDetails([]);
    return;
  }

  setLoadingAttendance(true);
  try {
    let formattedDate = new Date().toISOString().split("T")[0]; // Fallback today

    if (selectedDate) {
      // Assuming selectedDate format YYYY-MM-DD from input[type="date"]
      const parts = selectedDate.split("-");
      if (parts.length === 3 && parts[0].length === 4) {
        formattedDate = selectedDate; // Already YYYY-MM-DD
      } else if (typeof moment !== "undefined") {
        formattedDate = moment(selectedDate, "DD-MM-YYYY").format("YYYY-MM-DD");
      }
    }

    const response = await axios.get(
      `https://api.mirai.healthcare/api/attendance/StaffAttendance/attendence?date=${formattedDate}&staff_id=${staffId}`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-auth": authtoken || "",
        },
      }
    );

    if (response.data?.success && response.data?.data?.length > 0) {
      const staffData = response.data.data[0];
      const attendanceArr = staffData?.staffAttendance;

      if (!attendanceArr || attendanceArr.length === 0) {
        setAttendanceDetails([]);
      } else {
        const firstAttendance = attendanceArr[0];
        const statusObj = firstAttendance?.status || {};
        const inTimeObj = firstAttendance?.in_time || {};
        const outTimeObj = firstAttendance?.out_time || {};

        const shiftsData = Object.entries(statusObj).map(([shiftId, status]) => ({
          shiftId,
          status,
          inTime: inTimeObj[shiftId] || null,
          outTime: outTimeObj[shiftId] || null,
        }));

        setAttendanceDetails(shiftsData);
      }
    } else {
      setAttendanceDetails([]);
    }
  } catch (error) {
    console.error("Error fetching staff attendance:", error);
    setAttendanceDetails([]);
  } finally {
    setLoadingAttendance(false);
  }
};

// Auto-fetch attendance when contact person or visit date changes
useEffect(() => {
  if (formData.contact_to_id) {
    fetchStaffAttendance(formData.contact_to_id, formData.visit_date);
  } else {
    setAttendanceDetails([]);
  }
}, [formData.contact_to_id, formData.visit_date]);

const [otpPermissionLoading, setOtpPermissionLoading] = useState(true);
  const [otpRequired, setOtpRequired] = useState(false);

  useEffect(() => {
  const fetchOtpPermission = async () => {
    setOtpPermissionLoading(true);

    try {
      const response = await fetch(
        "https://api.mirai.healthcare/api/user/service-permission/filter?module_code=VISITOR-SMS-OTP&service_type=notification",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "x-auth": authtoken,
          },
        }
      );

      const result = await response.json();

      const allowService =
        result?.success === true &&
        result?.message?.services?.some(
          (service) =>
            service?.module_code === "VISITOR-SMS-OTP" &&
            service?.allow_service === true
        );

      setOtpRequired(allowService);
    } catch (error) {
      console.error("Error fetching OTP service permission:", error);

      // Safe side: API error hone par OTP required rakhein
      setOtpRequired(true);
    } finally {
      setOtpPermissionLoading(false);
    }
  };

  if (authtoken) {
    fetchOtpPermission();
  }
}, [authtoken]);

console.log(otpRequired, "otpRequired Data");

  return (
    <div className="page-wrapper min-vh-100 bg-light">
      <Header />

      <div className="content px-4 pt-5">
        {/* Page Header */}
        <div className="text-center mb-4">
          <h2 className="page-title fw-bold mb-0">Create Visitor Pass</h2>
          <p className="text-muted">
            Fill in visitor details and verify mobile via OTP
          </p>
        </div>

        <Row className="justify-content-center">
          <Col lg={12} xl={12}>
            <Card className="border-0 shadow-sm">
              {/* <Card.Header className="bg-white border-0 py-4">
                <h4 className="mb-0 text-center text-primary">
                  <People className="me-2" size={24} />
                  Visitor Information
                </h4>
              </Card.Header> */}

              <Card.Body className="p-4 p-md-5">
                <Form onSubmit={handleSubmit}>
                  <Row className="g-4">
                    {/* Personal Info - Disabled */}

                    <div className="col-md-4 mb-1">
  <label className="form-label" htmlFor="contact_to_id">
    Visitor Type
  </label>

  <Select
    id="visitor_type"
    classNamePrefix="react-select"
    value={
      formData.visitor_type
        ? { label: formData.visitor_type, value: formData.visitor_type }
        : null
    }
    onChange={(selected) =>
      handleDropdownVisitorTypeChange({
        value: selected.value,
      })
    }
    options={[
      { label: "Student", value: "Student" },
      { label: "Parent", value: "Parent" },
      { label: "Guardian", value: "Guardian" },
    ]}
    placeholder="Select Visitor Type"
    isSearchable={false}
    styles={customStyles}
    required
  />
</div>

                    {formData.visitor_type === "Parent" && (
                      <div className="col-md-4 mb-1">
                        <label className="form-label" htmlFor="relation">
                          Relation
                        </label>

                        <Select
                          id="relation"
                          classNamePrefix="react-select"
                          value={
                            formData.visitor_relation
                              ? {
                                  label: formData.visitor_relation,
                                  value: formData.visitor_relation,
                                }
                              : null
                          }
                          onChange={(selected) =>
                            handleDropdownRelationDataChange({
                              value: selected.value,
                            })
                          }
                          options={relationOptions}
                          placeholder="Select Relation"
                          isSearchable={false}
                          styles={customStyles}
                        />
                      </div>
                    )}

                    {["name", "mobile_no", "email", "address"].map((field) => (
                      <Col md={4} key={field}>
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            {field === "name" && (
                              <Person className="me-2 text-info" size={18} />
                            )}
                            {field === "mobile_no" && (
                              <Phone className="me-2 text-info" size={18} />
                            )}
                            {field === "email" && (
                              <Envelope className="me-2 text-info" size={18} />
                            )}
                            {field === "address" && (
                              <GeoAlt className="me-2 text-info" size={18} />
                            )}
                            {field.charAt(0).toUpperCase() +
                              field.slice(1).replace("_", " ")}
                          </Form.Label>
                          <Form.Control
  type={field === "email" ? "email" : "text"}
  value={formData[field]}
  onChange={(e) => handleChange(field, e.target.value)}  // ✅ ADD THIS
  placeholder={
    formData.visitor_type === "Guardian"
      ? `Enter ${field.replace("_", " ")}`
      : ""
  }
  disabled={
    formData.visitor_type === "Student" || 
    (formData.visitor_type === "Parent" && formData.visitor_relation !== "Guardian")
  }
/>
                        </Form.Group>
                      </Col>
                    ))}

                    {/* OTP Verification Section */}
                    {/* OTP Verification Section */}
                    {otpRequired && (
                    <Col md={12}>
                      <div className="border rounded-3 p-4 bg-light">
                        <div className="d-flex align-items-center mb-3">
                          <ShieldLock className="text-primary me-2" size={22} />
                          <h5 className="mb-0">
                            Mobile Or Email Verification (Required)
                          </h5>
                          {otpVerified && (
                            <Badge bg="success" className="ms-auto">
                              Verified ✓
                            </Badge>
                          )}
                        </div>

                        {!otpVerified ? (
                          <>
                            {!otpSent ? (
                              <Button
                                variant="outline-primary"
                                onClick={sendOtp}
                                disabled={otpLoading || !formData.mobile_no}
                              >
                                {otpLoading ? (
                                  <>
                                    <Spinner size="sm" className="me-2" />
                                    Sending OTP...
                                  </>
                                ) : (
                                  "Send OTP"
                                )}
                              </Button>
                            ) : (
                              <Row className="align-items-center">
                                <Col md={6}>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter 6-digit OTP"
                                    value={otp}
                                    onChange={(e) =>
                                      setOtp(
                                        e.target.value
                                          .replace(/\D/g, "")
                                          .slice(0, 6)
                                      )
                                    }
                                    maxLength={6}
                                  />
                                </Col>
                                <Col md={6}>
                                  <div className="d-flex gap-2">
                                    <Button
                                      variant="success"
                                      onClick={verifyOtp}
                                      disabled={otpLoading || otp.length !== 6}
                                      className="flex-fill"
                                    >
                                      {otpLoading
                                        ? "Verifying..."
                                        : "Verify OTP"}
                                    </Button>
                                    <Button
                                      variant="outline-secondary"
                                      onClick={sendOtp}
                                      disabled={otpLoading || resendTimer > 0}
                                    >
                                      {otpLoading ? (
                                        <Spinner size="sm" />
                                      ) : resendTimer > 0 ? (
                                        `Resend in ${resendTimer}s`
                                      ) : (
                                        "Resend"
                                      )}
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            )}
                            {otpSent && !otpVerified && (
                              <small className="text-muted d-block mt-2">
                                OTP sent to {formData.mobile_no} or{" "}
                                {formData.email}
                              </small>
                            )}
                          </>
                        ) : (
                          <Alert variant="success" className="mb-0">
                            <ShieldLock className="me-2" />
                            OTP verified successfully!
                          </Alert>
                        )}
                      </div>
                    </Col>
                    )}

                    {/* Department - React Select */}
                    <Col md={4}>
                      <Form.Label className="fw-semibold">
                        <Building className="me-2 text-info" size={18} />
                        Department <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        options={departmentOptions}
                        value={
                          departmentOptions.find(
                            (o) => o.value === formData.department_id
                          ) || null
                        }
                        onChange={(opt) =>
                          handleChange("department_id", opt?.value || "")
                        }
                        placeholder="Select Department"
                        isSearchable
                        styles={customStyles}
                        required
                      />
                    </Col>

                    {/* Contact Person - React Select */}
                    <Col md={4}>
                      <Form.Label className="fw-semibold">
                        <People className="me-2 text-info" size={18} />
                        Contact Person  
                        {/* <span className="text-danger">*</span> */}
                      </Form.Label>
                      {/* <Select
                        options={staffOptions}
                        value={
                          staffOptions.find(
                            (o) => o.value === formData.contact_to
                          ) || null
                        }
                        onChange={(opt) =>
                          handleChange("contact_to", opt?.value || "")
                        }
                        placeholder={
                          formData.department_id
                            ? "Select Staff"
                            : "First select department"
                        }
                        isDisabled={!formData.department_id}
                        isSearchable
                        styles={customStyles}
                        required
                      /> */}
                      <Select
  options={staffOptions}
  value={staffOptions.find((option) => option.value === formData.contact_to_id)}
  onChange={(selectedOption) => {
    handleChange("contact_to_id", selectedOption?.value || "");
    
    // Save formatted string with employee code to state
    const formattedLabel = selectedOption 
      ? `${selectedOption.label.trim()}${selectedOption.employee_code ? ` (${selectedOption.employee_code})` : ""}`
      : "";
      
    handleChange("contact_to", formattedLabel);
  }}
  getOptionLabel={(option) => 
    option.employee_code ? `${option.label.trim()} (${option.employee_code})` : option.label
  }
   placeholder={formData.department_id ? "Select Staff" : "First select department"}
   isDisabled={!formData.department_id}
  isSearchable={true}
  styles={customStyles}
/>

  {/* Status display section right below contact person */}
  {formData.contact_to_id && (
    <div className="mt-2 fs-14">
      <span className="fw-semibold text-secondary me-1">Status:</span>
      {loadingAttendance ? (
        <span className="badge bg-light text-muted border">
          <i className="fa fa-spinner fa-spin me-1"></i> Loading...
        </span>
      ) : attendanceDetails.length > 0 ? (
        <div className="d-flex flex-wrap gap-1 align-items-center mt-1">
          {attendanceDetails.map((item, index) => (
            <span
              key={index}
              className={`badge ${
                item.status?.toLowerCase() === "present"
                  ? "bg-success-subtle text-success border border-success-subtle"
                  : item.status?.toLowerCase() === "absent"
                  ? "bg-danger-subtle text-danger border border-danger-subtle"
                  : "bg-warning-subtle text-warning border border-warning-subtle"
              } px-2 py-1 text-capitalize`}
            >
              Shift {item.shiftId}: {item.status}
            </span>
          ))}
        </div>
      ) : (
        <span className="badge bg-warning-subtle text-warning border border-warning-subtle px-2 py-1 text-capitalize ms-1">
          Not Mark
        </span>
      )}
    </div>
  )}
                    </Col>

                    <Col md={4}>
                      <Form.Label className="fw-semibold">
                        <Calendar3 className="me-2 text-info" size={18} />
                        Visit Date <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        value={formData.visit_date}
                        onChange={(e) =>
                          handleChange("visit_date", e.target.value)
                        }
                        min={today}
                        required
                      />
                    </Col>

                    <Col md={12}>
                      <Form.Label className="fw-semibold">
                        Purpose of Visit <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Enter purpose of visit..."
                        value={formData.purpose}
                        onChange={(e) =>
                          handleChange("purpose", e.target.value)
                        }
                        required
                      />
                    </Col>

                    {/* Photo & Document Uploads */}
                    <Col md={6}>
                      <Form.Label className="fw-semibold">
                        <ImageIcon className="me-2 text-info" size={18} />
                        Visitor Photo (Optional)
                      </Form.Label>
                      <div className="border rounded-3 p-3 text-center bg-light">
                        {previews.photo ? (
                          <img
                            src={previews.photo}
                            alt="Preview"
                            className="img-fluid rounded mb-3"
                            style={{ maxHeight: "180px" }}
                          />
                        ) : (
                          <div
                            className="bg-secondary bg-opacity-10 rounded-3 d-flex align-items-center justify-content-center mb-3"
                            style={{ height: "180px" }}
                          >
                            <ImageIcon size={48} className="text-muted" />
                          </div>
                        )}
                       
                        <Col md={12}>

  <div className="d-flex gap-2">
    <Form.Control
      type="file"
      accept="image/*"
      onChange={(e) => handlePhotoChange(e.target.files[0])}
    />

    <Button onClick={() => openWebcam("photo")}>
      <FaCamera />
    </Button>

    {/* iOS native camera (photo + document dono ke liye ek hi input) */}
    <input
      ref={cameraInputRef}
      type="file"
      accept="image/*"
      capture="environment"
      hidden
      onChange={handleNativeCapture}
    />
  </div>

  {/* Webcam */}
  {showWebcam.photo && (
    <div className="mt-3 text-center">
      <Webcam ref={webcamRef} screenshotFormat="image/jpeg" width={300} />

      <div className="mt-2">
        <Button variant="success" onClick={captureImage}>
          Capture
        </Button>
        <Button
          variant="danger"
          className="ms-2"
          onClick={() =>
            setShowWebcam((prev) => ({ ...prev, photo: false }))
          }
        >
          Cancel
        </Button>
      </div>
    </div>
  )}

</Col>

                        <small className="text-muted">Max 4MB • JPG, PNG</small>
                      </div>
                    </Col>

                    <Col md={6}>
                      <Form.Label className="fw-semibold">
                        <FileText className="me-2 text-info" size={18} />
                        Document / ID Proof (Optional)
                      </Form.Label>
                      <div className="border rounded-3 p-3 text-center bg-light">
                          {previews.document ? (
  <div className="text-center">
    {/* ✅ Check file type */}
    {formData.document?.type?.includes("image") ? (
      <img
        src={previews.document}
        alt="Document Preview"
        className="img-fluid rounded mb-2"
        style={{ maxHeight: "180px" }}
      />
    ) : formData.document?.type === "application/pdf" ? (
      <iframe
        src={previews.document}
        title="PDF Preview"
        width="100%"
        height="180px"
        className="mb-2"
      />
    ) : (
      <>
        <FileText size={60} className="text-primary mb-2" />
        <p className="mb-0">Document Selected</p>
      </>
    )}
  </div>
                        ) : (
                          <div
                            className="bg-secondary bg-opacity-10 rounded-3 d-flex align-items-center justify-content-center mb-3"
                            style={{ height: "180px" }}
                          >
                            <FileText size={48} className="text-muted" />
                          </div>
                        )}
                        <Col md={12}>

  <div className="d-flex gap-2">
    <Form.Control
      type="file"
      accept="image/*,application/pdf"
      onChange={(e) => handleDocumentChange(e.target.files[0])}
    />

    <Button onClick={() => openWebcam("document")}>
      <FaCamera />
    </Button>
  </div>

  {/* Webcam */}
  {showWebcam.document && (
    <div className="mt-3 text-center">
      <Webcam ref={webcamRef} screenshotFormat="image/jpeg" width={300} />

      <div className="mt-2">
        <Button variant="success" onClick={captureImage}>
          Capture
        </Button>
        <Button
          variant="danger"
          className="ms-2"
          onClick={() =>
            setShowWebcam((prev) => ({ ...prev, document: false }))
          }
        >
          Cancel
        </Button>
      </div>
    </div>
  )}

  
</Col>
                        <small className="text-muted">
                          Max 4MB • JPG, PNG, PDF
                        </small>
                      </div>
                    </Col>
                  </Row>

                  <div className="text-center mt-5">
                    {/* <Button
                      type="submit"
                      size="lg"
                      variant={otpVerified ? "primary" : "secondary"}
                      className="px-5"
                      disabled={loading || !otpVerified}
                    >
                      {loading ? (
                        <>
                          <Spinner size="sm" className="me-2" />
                          Creating Pass...
                        </>
                      ) : (
                        <>
                          <Upload className="me-2" size={20} />
                          Create Visitor Pass
                        </>
                      )}
                    </Button> */}
                    <Button
                      type="submit"
                      size="lg"
                      variant={otpVerified ? "primary" : "secondary"}
                      className="px-5"
                      disabled={loading || otpPermissionLoading}
                    >
                      {loading
    ? "Submitting..."
    : otpPermissionLoading
    ? "Checking permission..."
    : "Submit"}
                    </Button>
                    {otpRequired && !otpVerified && (
                      <p className="text-muted mt-3 mb-0">
                        Please verify mobile number with OTP to enable
                        submission
                      </p>
                    )}
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      <style jsx>{`
        .form-control:disabled {
          background-color: #f8f9fa;
          opacity: 0.8;
        }
        .card {
          border-radius: 1rem;
        }
        .card-header {
          border-radius: 1rem 1rem 0 0 !important;
        }
        .form-control,
        .form-select {
          border-radius: 0.75rem;
          padding: 0.75rem 1rem;
        }
      `}</style>
    </div>
  );
};

export default AddVisitor;
